import styled from 'styled-components'

const TermsStyle = styled.div`
	--contentLeftFix: var(--sp11x);
	--contentTop: var(--sp22x);
	--accordionWrapperTop: var(--sp13x);
	--accordionWrapperLeft: var(--sp22x);
	--accordionPaddings: var(--sp7x);
	--accordionTitleWidth: 98%;

	margin-left: var(--contentLeftFix);
	padding-top: var(--contentTop);
	margin-bottom: var(--sectionMarginBottom);
	word-break: break-word;

	.description {
		margin-top: var(--sp4x);
	}
	.accordionWrapper {
		margin-top: var(--accordionWrapperTop);
		padding-left: var(--accordionWrapperLeft);
		margin-left: auto;
		width: 100%;

		.accordion {
			box-shadow: none;
			border-top: 1px solid var(--grey);
			background: transparent;
			overflow: hidden;

			.collapse {
				max-height: 0;
				transition: max-height var(--trTime2) ease-in;
			}

			.collapseOpened {
				max-height: 100%;
				visibility: visible;
				transition: max-height var(--trTime2) ease-out;
			}
			.accordionSummary {
				margin: 0;
				padding: 0;
				position: relative;
				.accordionTitle {
					padding: var(--accordionPaddings) 0 var(--accordionPaddings) 0;
					width: var(--accordionTitleWidth);
				}
				.icon {
					position: absolute;
					right: 0;
					width: var(--sp4x);
					height: var(--sp0-5x);
					background: var(--black);
					top: 50%;
                    cursor: pointer;

					&.active {
						&:after {
							opacity: 0;
						}
					}
				}

				.icon::after {
					content: '';
					width: var(--sp4x);
					height: var(--sp0-5x);
					background: var(--black);
					position: absolute;
					transform: rotate(90deg);
					opacity: 1;
					transition: all 350ms ease;
				}
			}
			.dangerHTML {
				font-family: geoRegular;
				padding: 0 0 var(--accordionPaddings) 0;
				p {
					font-size: var(--h7);
				}
			}
		}
		.accordion:last-child {
			border-bottom: 1px solid var(--grey);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--contentLeftFix: var(--sp4x);
		--contentTop: var(--sp16-5x);
		--accordionWrapperTop: var(--sp12x);
		--accordionWrapperLeft: var(--sp17x);
		--accordionPaddings: var(--sp6x);
		--accordionTitleWidth: 97%;
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--contentLeftFix: var(--sp6x);
		--contentTop: var(--sp13-5x);
		--accordionWrapperTop: var(--sp10x);
		--accordionWrapperLeft: var(--sp15x);
		--accordionPaddings: var(--sp5x);
		--accordionTitleWidth: 96%;
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--contentLeftFix: var(--sp5x);
		--contentTop: var(--sp12-5x);
		--accordionWrapperTop: var(--sp9x);
		--accordionWrapperLeft: var(--sp13x);
		--accordionPaddings: var(--sp4x);
		--accordionTitleWidth: 96%;
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--contentLeftFix: 0;
		--contentTop: var(--sp10x);
		--accordionWrapperTop: var(--sp7x);
		--accordionWrapperLeft: 0;
		--accordionPaddings: var(--sp3x);
		--accordionTitleWidth: 96%;
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		--contentLeftFix: 0;
		--contentTop: var(--sp10x);
		--accordionWrapperTop: var(--sp7x);
		--accordionWrapperLeft: 0;
		--accordionPaddings: var(--sp3x);
		--accordionTitleWidth: 94%;
	}
	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--contentLeftFix: 0;
		--contentTop: var(--sp9x);
		--accordionWrapperTop: var(--sp6x);
		--accordionWrapperLeft: 0;
		--accordionPaddings: var(--sp3x);
		--accordionTitleWidth: 90%;
	}
`

export default TermsStyle
